// modules/estrategias/rbc/api/RBCAPI.js
// Solo Discapacidad (sin salud mental, tamizajes, talleres, verificación ni
// bloqueo — eso no se trajo del SI-PIC a propósito).
import axiosClient from "../../../inicio/api/axiosClient";

export const getPersonas = (params) => axiosClient.get("/rbc/discapacidad", { params });
export const getPersonaById = (id) => axiosClient.get(`/rbc/discapacidad/${id}`);
export const createPersona = (data) => axiosClient.post("/rbc/discapacidad", data);
export const updatePersona = (id, data) => axiosClient.put(`/rbc/discapacidad/${id}`, data);
export const deletePersona = (id) => axiosClient.delete(`/rbc/discapacidad/${id}`);
export const exportarExcelRBC = (params) => axiosClient.get("/rbc/discapacidad/exportar", { params, responseType: "blob" });
export const descargarPdfRBC = (id) => axiosClient.get(`/rbc/discapacidad/${id}/pdf`, { responseType: "blob" });
// La misma ficha en HTML, para convertirla a PDF en el navegador cuando el
// servidor no puede generar PDF (hosting sin las librerías de Chrome).
export const obtenerFichaHtmlRBC = (id) => axiosClient.get(`/rbc/discapacidad/${id}/ficha`, { responseType: "text" });

// Consentimiento informado (PDF) — requiere conexión siempre, no se
// encola offline (mismo criterio que las fichas: es un archivo, no un
// dato liviano para meter en la cola de sincronización).
export const subirConsentimientoRBC = (id, archivo) => {
  const formData = new FormData();
  formData.append("archivo", archivo);
  return axiosClient.post(`/rbc/discapacidad/${id}/consentimiento`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const eliminarConsentimientoRBC = (id) => axiosClient.delete(`/rbc/discapacidad/${id}/consentimiento`);

// Alias usados por offline/discapacidadOffline.js (nombres más explícitos
// para no confundirse con las funciones de arriba al leer el código de sync).
export const crearPersonaAPI = createPersona;
export const actualizarPersonaAPI = updatePersona;